import { NumberFormat } from '@lightspeed/i18n-number-format';
import { Styles } from '@lightspeed/i18n-number-format/types';

export const formatCurrency = (
  total: number | string,
  currency: string = window.merchantos.locale.currency_code,
  roundToWhole: boolean = false
) => {
  const userLocale = window.merchantos.locale.lang || 'en-US';

  const fmt = new NumberFormat({ locale: userLocale });
  const price = typeof total === 'string' ? parseFloat(total) : total;

  const formatOptions = roundToWhole
    ? {
        style: 'currency' as Styles,
        currencyCode: currency,
        minimumFractionDigits: 0,
      }
    : {
        style: 'currency' as Styles,
        currencyCode: currency,
      };

  const formattedMoney = fmt.format(price, formatOptions);
  return formattedMoney as string;
};

export const formatNumber = (total: number | string) => {
  const userLocale = window.merchantos.locale.lang || 'en-US';

  const fmt = new NumberFormat({ locale: userLocale });
  const price = typeof total === 'string' ? parseFloat(total) : total;

  const formatQuantity = fmt.format(price, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatQuantity as string;
};

/**
 * Utility function that converts a date (in m/d/Y g:i a format)
 * to MM/dd/yyyy h:mm AM/PM (or dd/MM/yyyy h:mm AM/PM depending on account
 * settings).
 *
 * @param {String} dateFormat The unformatted date
 * @param {String} dateFormat The Date Format in the account -
 *     either m/d/Y g:i a  or d/m/Y g:i a
 *
 * @return {String} The formatted date
 */
export const DatePickerFormat = (dateFormat: string) => {
  const replacements = {
    m: 'MM',
    d: 'dd',
    Y: 'yyyy',
    g: 'hh',
    i: 'mm',
    a: 'a',
  };

  return dateFormat
    .split('')
    .map((chr) => (chr in replacements ? (replacements as any)[chr] : chr))
    .join('');
};

/**
 * Converts php date time format to momentjs format
 * @param str php date_time format
 */
export const phpToMoment = (str: string) => {
  const replacements = {
    d: 'DD', // 01 -31 with zero
    D: 'ddd', // mon - sun
    j: 'D', // 1 to 31 without zero
    l: 'dddd', // A full textual representation of the day of the week - Sunday through Saturday
    N: 'E', // ISO day of week 1-7
    S: 'o', // st, nd, rd or th. Works well with j
    w: 'e', // 0 (for Sunday) through 6 (for Saturday)
    z: 'DDD', // 	0 through 365
    W: 'W', // week number of year
    F: 'MMMM', // full textual month
    m: 'MM', // Numeric representation of a month, with leading zeros
    M: 'MMM', // Jan through Dec
    n: 'M', // 	1 through 12
    t: '', // no equivalent
    L: '', // no equivalent
    o: 'YYYY', // Examples: 1999 or 2003
    Y: 'YYYY', // Examples: 1999 or 2003
    y: 'YY', // Examples: 99 or 03
    a: 'a', // am or pm
    A: 'A', // AM or PM
    B: '', // no equivalent
    g: 'h', // 12-hour format no zero
    G: 'H', // 24-hour format no zero
    h: 'hh', // 12-hour format with zero
    H: 'HH', // 24-hour format with zero
    i: 'mm', // Minutes with leading zeros
    s: 'ss', // Seconds with leading zeros
    u: 'SSS', // Microseconds
    e: 'zz', // deprecated since Moment.js 1.6.0
    I: '', // no equivalent
    O: '', // no equivalent
    P: '', // no equivalent
    T: '', // no equivalent
    Z: '', // no equivalent
    c: '', // no equivalent
    r: '', // no equivalent
    U: 'X', // Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)
  };

  return str
    .split('')
    .map((chr) => (chr in replacements ? (replacements as any)[chr] : chr))
    .join('');
};
